import { render } from "./TeamEditorModal.vue?vue&type=template&id=2b4d924c&scoped=true&ts=true"
import script from "./TeamEditorModal.vue?vue&type=script&lang=ts"
export * from "./TeamEditorModal.vue?vue&type=script&lang=ts"

import "./TeamEditorModal.vue?vue&type=style&index=0&id=2b4d924c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b4d924c"]])

export default __exports__